<template>
<div id="ArrearsAlarmSetting">
     <el-button type="info" @click="dialogFormVisible = true">欠费报警设置</el-button >
     <el-dialog title="电表详情" :visible.sync="dialogFormVisible">
      <el-form :model="form">
   
        <el-form-item label="欠费告警金额(元):">
          <el-input v-model="form.name" ></el-input>
        </el-form-item>

        <el-form-item label="欠费告警金额(元):">
          <el-input v-model="form.maxy"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dps">确 定</el-button>
      </div>
    </el-dialog>
</div>
</template>
<script>
export default {
    name:"ArrearsAlarmSetting",
 data() {
    return {
      dialogFormVisible: false,
      form: {
        name: "",
        maxy: "",
      },
      formLabelWidth: "100px",
    };
  },
    methods: {
    dps() {
      console.log(
        this.form.name,
        this.form.maxy,
      );
      this.dialogFormVisible = false;
    },
  },

}
</script>
<style lang="less" scoped>
#ArrearsAlarmSetting{
    width: 100%;
    height: 100%;

  .el-form-item__content{
    .w(500) !important
  }
}

</style>